<template>
    <Card>
        <div class="card-body">
            <router-link 
                class="btn btn-link"
                :to="{name: 'CreateTagsCard'}"
            >
                <i class="icon-plus3 mr-2"></i>
                {{ $t("buttons.create") }}
            </router-link>
        </div>
        <FetchTable
            url="/integration-product-tags"
            :handle="tableHandle"
            :columns="columns"
            :orders="orders"
            has-checkbox
            @update:selectedValues="selectedTags = $event"
            @update:orders="orders = $event"
        >
            <template #actionDropdownItems>
                <DropdownItem @click="deleteSelectedTags">{{ $t('buttons.delete') }}</DropdownItem>
            </template>
            <template #td-id="{row}">
                <router-link :to="{name: 'EditTagsCard', params: {integrationProductTagUuid: row.uuid}}">
                    {{ row.id }}
                </router-link>
            </template>
            <template #td-created_at="{row}">
                <span>{{ DateFormatter.formatDateTime(row.created_at) }}</span>
            </template>
        </FetchTable>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import FetchTable from "../../../../components/new/table/FetchTable.vue";
import DropdownItem from "../../../components/btnDropdown/DropdownItem.vue";
import { createTableHandle } from "../../../../components/new/table/tableHandle";

import DateFormatter from "../../../../services/DateFormatter";
import HttpRequest from "../../../../services/Http/HttpRequest";
import HttpSender from "../../../../services/Http/HttpSender";
import MessageNotificator from "../../../../services/MessageNotificator";

export default {
    name: 'TagsCard',
    components: {
        Card, FetchTable, DropdownItem
    },
    data() {
        return {
            DateFormatter,
            tableHandle: createTableHandle(),
            selectedTags: [],
            columns: [
                {key: "id", name: this.$t('table.titles.id'), width: "100px", type: "string", order: true},
                {key: "name", name: this.$t('table.titles.name'), width: "auto", type: "string", order: true},
                {key: "created_at", name: this.$t('table.titles.created_at'), width: "200px", type: "date", order: true},
            ],
            orders: [
                {column: 'name', dir: 'asc'}
            ]
        }
    },
    methods: {
        async deleteSelectedTags() {
            new MessageNotificator().confirm(this.$t('alerts.confirm_delete'), async () => {
                let requests = [];

                for (let tagUuid of this.selectedTags) {
                    requests.push(new HttpRequest('DELETE', `/integration-product-tags/${tagUuid}`));
                }

                await new HttpSender().sendRequestsInBatches(requests, () => {});

                this.tableHandle.fetchRows();
            })
        }
    },
    mounted() {
        this.tableHandle.fetchRows();
    }
};
</script>